// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {TweenMax} from 'gsap';

// CLASS
import _video from './assets/js/video'
import _nav from './assets/js/nav'
import _transition from './assets/js/transition'
import _preload from './assets/js/preload'

const nav = new _nav();
const preload = new _preload();
const transition = new _transition()

// COMPONENTS
import gHeader from './components/header'
import gNav from './components/nav'
import gFooter from './components/footer'

// COMPONENTS
Vue.component('gHeader', gHeader)
Vue.component('gNav', gNav)
Vue.component('gFooter', gFooter)
Vue.config.productionTip = false

// PAGE CHANGE
const pageChange = (meta, to, from) => {
  console.log('meta:', meta)
  console.log('to:::', to)
  console.log('from:', from)
  console.log('------------------------------------')
  document.documentElement.dataset.page = to.name
  document.title = meta.title
  nav.close();
  // const video = new _video('video');
  // video.init().then(() => {
  //   video.play();
  // });
};

// VUE INSTANCE
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  watch: {
    '$route' (to, from) {
      window.scrollTo(0,0)
      // console.log('$route', '\r\n', to)
      pageChange(to.meta, to, from)
    }
  },
  mounted: () => {
    console.log('mounted')
    nav.init()
    pageChange(router.history.current.meta, router.history.current)
    preload.init().then(() => {
      let t = setTimeout(() => {
        clearTimeout(t);
        t = null;
        document.documentElement.classList.add('loadingDone');
      }, 2000)
    });
    router.beforeEach((to, from, next) => {
      next()
    });
  }
})



// WEBPACK FOOTER //
// ./src/main.js